import { render, staticRenderFns } from "./QrCodes.vue?vue&type=template&id=95c51d70&"
import script from "./QrCodes.vue?vue&type=script&lang=js&"
export * from "./QrCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports